import { render, staticRenderFns } from "./morble-table.vue?vue&type=template&id=4186dc21&scoped=true&"
import script from "./morble-table.vue?vue&type=script&lang=js&"
export * from "./morble-table.vue?vue&type=script&lang=js&"
import style0 from "./morble-table.vue?vue&type=style&index=0&id=4186dc21&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4186dc21",
  null
  
)

export default component.exports